import { render, staticRenderFns } from "./OptionCollapseParent.vue?vue&type=template&id=6b39f424"
import script from "./OptionCollapseParent.vue?vue&type=script&lang=ts"
export * from "./OptionCollapseParent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports